import req from './../../fetch';
import { undocumentedResponse } from './../../utils';
import {
  AllAPIResponses,
  CarbonError,
  NodeTypeTemplateType,
} from './../../index';

type Payload = {
  name: string;
};
const post = async (
  payload: Payload,
  headers?: Headers
): Promise<AllAPIResponses<NodeTypeTemplateType>> => {
  try {
    const resp = await req.post(
      '/api/nodetypetemplates',
      JSON.stringify(payload),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as NodeTypeTemplateType,
          response: clone,
        };
      case 304:
        return { error: new Error('Not Modified'), response: clone };

      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
